import {
  borderWidth,
  brand,
  focus,
  fonts,
  layout,
  maxWidths,
  motion2 as motion,
  opacity,
  product,
  productBreakpoints,
  productRadii,
  productSpacing,
  productTypeScale,
  semanticDark,
  semanticLight,
  shadows,
  zIndex
} from "./chunk-RWJTCKM5.mjs";

// src/tokens/product-theme.ts
var productTheme = {
  colors: {
    ...brand,
    ...product
  },
  fonts: fonts.product,
  typeScale: productTypeScale,
  spacing: productSpacing,
  radii: productRadii,
  shadows,
  motion,
  breakpoints: productBreakpoints,
  maxWidth: maxWidths.product,
  /** Semantic color tokens — dark theme */
  semantic: semanticDark,
  /** Semantic color tokens — light theme */
  semanticLight,
  /** Z-index scale */
  zIndex,
  /** Border width scale */
  borderWidth,
  /** Opacity scale */
  opacity,
  /** Layout dimensions */
  layout,
  /** Focus ring tokens */
  focus
};

export {
  productTheme
};
//# sourceMappingURL=chunk-7AV5FO4O.mjs.map